/*
 * Code generated by maegi. DO NOT EDIT.
 */

import type React from "react";

export const DownloadImage16 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15 0H1C.4 0 0 .4 0 1v14c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1M6 4c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1m-3 8 2-4 2 2 3-4 3 6z"
    />
  </svg>
);

export const __descriptor_DownloadImage = {
  name: "DownloadImage",
  instances: [{ size: 16, Component: DownloadImage16 }],
} as const;
